<p class="laft-form--title">Completa tus datos personales</p>
<form class="laft-form" [formGroup]="personalDataForm">
  <section class="laft-form--group">
    <p class="laft-form--group-title">Datos de la cuenta</p>
    <div class="form-group-3">
      <app-input formControlName="names" label="Nombres" maxlength="50"></app-input>
      <app-input formControlName="firstLastName" label="Primer apellido" maxlength="50"></app-input>
      <app-input formControlName="secondLastName" label="Segundo apellido" maxlength="50"></app-input>
    </div>
    <div>
      <app-select
        *ngIf="personalDataForm.get('idType').value !== 'ruc'"
        formControlName="nationality"
        [options]="countryOptions"
        valueField="value"
        textField="text"
        label="Nacionalidad"
        isDisabled="false"
      ></app-select>
    </div>
    <div class="form-group-3">
      <app-select
        formControlName="idType"
        defaultOption="national id"
        [options]="idTypeOptions"
        valueField="value"
        textField="text"
        label="Tipo de documento"
      ></app-select>
      <app-input formControlName="idNumber" label="Número de documento"></app-input>
      <div class="laft-form--input-phone">
        <span class="laft-form--input-phone-label" [ngClass]="phoneError ? 'laft-form--input-phone-label-error' : ''">
          Teléfono celular <span *ngIf="phoneError"> ({{ phoneError }})</span>
        </span>
        <ngx-intl-tel-input
          [preferredCountries]="preferredCountries"
          [enableAutoCountrySelect]="true"
          [enablePlaceholder]="true"
          customPlaceholder="Ingresa tu número"
          [searchCountryFlag]="true"
          [searchCountryField]="[searchCountryField.Iso2, searchCountryField.Name]"
          [selectFirstCountry]="false"
          [selectedCountryISO]="countryISO.Peru"
          [maxLength]="phoneNumberMaxDigit"
          [phoneValidation]="true"
          [separateDialCode]="true"
          [numberFormat]="phoneNumberFormat.International"
          searchCountryPlaceholder="Elegir país"
          formControlName="cellphone"
          (focusout)="focusOutPhone()"
          (countryChange)="countryChange($event)"
        >
        </ngx-intl-tel-input>
      </div>
    </div>
    <app-input
      class="signup-email-input"
      formControlName="email"
      label="Correo electrónico"
      isDisabled="true"
    ></app-input>
  </section>

  <section class="laft-form--group">
    <p class="laft-form--group-title">Información personal</p>
    <div class="form-group-2">
      <app-date-picker formControlName="birthDate" label="Fecha de nacimiento"></app-date-picker>
      <app-select
        formControlName="maritalStatus"
        [options]="maritalStatusOptions"
        valueField="value"
        textField="text"
        label="Estado civil"
      ></app-select>
    </div>
    <p class="laft-form--text-indicator u-mb-2">Lugar de residencia</p>
    <div class="form-group-4">
      <app-select
        formControlName="country"
        [options]="countryOptions"
        valueField="value"
        [defaultOption]="PERU"
        textField="text"
        label="País"
      ></app-select>
      <app-select
        formControlName="department"
        [options]="departmentOptions"
        valueField="value"
        textField="text"
        label="Departamento"
        [isDisabled]="isDepartmentDisabled"
      ></app-select>
      <app-select
        formControlName="province"
        [options]="provinceOptions"
        valueField="value"
        textField="text"
        label="Provincia"
        [isDisabled]="isProvinceDisabled"
      ></app-select>
      <app-select
        formControlName="district"
        [options]="districtOptions"
        valueField="value"
        textField="text"
        label="Distrito"
        [isDisabled]="isDistrictDisabled"
      ></app-select>
    </div>
    <app-input formControlName="address" label="Dirección" helperText="Ejemplo: Avenida Lima 123" errorText=" (Debe ser una dirección real)"></app-input>
  </section>

  <section *ngIf="personalDataForm.get('maritalStatus').value === MARRIED_STATUS || personalDataForm.get('maritalStatus').value === COHABITING_STATUS" class="laft-form--group">
    <p class="laft-form--group-title">Información del cónyuge</p>
    <div class="form-group-2">
      <app-input formControlName="partnerNames" label="Nombres" maxlength="50"></app-input>
      <app-input formControlName="partnerLastNames" label="Apellidos" maxlength="50"></app-input>
    </div>
    <div class="form-group-2">
      <app-select
        formControlName="partnerIdType"
        [options]="idPartnerTypeOptions"
        valueField="value"
        textField="text"
        (OnSelectionChanged)="idTypeChanged($event)"
        label="Tipo de documento"
      ></app-select>
      <app-input formControlName="partnerIdNumber" label="Número de documento"></app-input>
    </div>
    <div class="laft-form--checkbox">
      <app-checkbox
        formControlName="separateProperty"
        [checked]="personalDataForm.get('separateProperty').value"
      ></app-checkbox>
      <p class="u-mt-1 laft-form--text-indicator">Bienes separados</p>
    </div>
    <div *ngIf="personalDataForm.get('separateProperty').value">
      <p class="laft-form--text-indicator u-mb-3">Certificado de separación de bienes</p>
      <lib-file-upload
        label="Documento"
        [iconUpload]="true"
        internalSpacing="s"
        formats="image+pdf"
        [getFileName]="true"
        [initialLabel]="'Subir certificado de separación de bienes'"
        formControlName="idCertificatePicture"
      >
      </lib-file-upload>
    </div>
  </section>

  <section class="laft-form--group">
    <p class="laft-form--group-title">Actividad económica</p>
    <div class="form-group-2">
      <app-select
        formControlName="educationLevel"
        [options]="educationLevelOptions"
        valueField="value"
        textField="text"
        label="Nivel de estudios"
      ></app-select>
      <app-input formControlName="occupation" label="Ocupación"></app-input>
    </div>
    <div class="form-group-2">
      <app-select
        formControlName="economicActivityType"
        [options]="economicActivityTypeOptions"
        valueField="value"
        textField="text"
        label="Tipo de actividad económica"
      ></app-select>
      <app-select
        formControlName="mainEconomicActivity"
        [options]="mainEconomicActivityOptions"
        valueField="value"
        textField="text"
        label="Principal actividad económica"
      ></app-select>
    </div>
    <app-input
      class="laft-form--input-activity"
      *ngIf="personalDataForm.get('mainEconomicActivity').value === 'otros'"
      helperText="Ej. Servicios, financiero, minero, construcción, inmobiliario, etc."
      formControlName="mainEconomicActivityOther"
      label="Especifica la principal actividad económica"
    ></app-input>
    <div class="form-group-2">
      <app-select
        formControlName="annualIncome"
        [options]="annualIncomeOptions"
        valueField="value"
        textField="text"
        label="Ingresos anuales"
      ></app-select>
      <app-select *ngIf="personalDataForm.get('estimatedPatrimony')"
        formControlName="estimatedPatrimony"
        [options]="estimatedPatrimonyOptions"
        valueField="value"
        textField="text"
        label="Patrimonio estimado"
      ></app-select>
    </div>
  </section>
  <div class="laft-form--actions">
    <button type="button" class="laft-form--btn-submit" (click)="onContinue()">Continuar</button>
  </div>
</form>
